import React, { Component } from 'react';
import Loading from './Loading';
import Home from './Home';
import { connect } from "react-redux";
import {  get_categories, get_foods, get_allergens, get_images } from '../api/UserFunctions';
import { changeCategories, changeFoods, changeAllergens, changeImages } from "../actions/index";

function mapDispatchToProps(dispatch) {
    return {
      changeCategories:categories => dispatch(changeCategories(categories)),
      changeFoods:foods => dispatch(changeFoods(foods)),
      changeAllergens:allergens => dispatch(changeAllergens(allergens)),
      changeImages:images => dispatch(changeImages(images))
    };
}

const mapStateToProps = state => {
 return{ connexion: state.connexion}
};

class Connexion extends Component {
	constructor(props){
    super(props);
    this.state={
      categories:false,
      foods:false,
      allergens:false,
      images:false,
      loading:false
    }

    

  }



  componentDidMount(){
    setTimeout(function () {
      this.setState({loading:true});
    }.bind(this), 2000);

    get_categories().then(res => {
        this.setState({categories:res});
        this.props.changeCategories(res);
        
    });

    get_foods().then(res => {
      this.setState({foods:res});
      this.props.changeFoods(res);
    });

    get_allergens().then(res => {
      this.setState({allergens:res});
      this.props.changeAllergens(res);
    });

    get_images().then(res => {
      this.setState({images:res});
      this.props.changeImages(res);
    });

    
      
    }

  render() {
    let push = this.props.home;
    if( this.state.categories && this.state.foods && this.state.allergens && this.state.images && this.state.loading){
      if(typeof(this.props.connexionAuth)!=="undefined"){
        return (      
          <div>
            <Home connexionAuth={this.props.connexionAuth}/> 
          </div>
          );
      }
      else{
        return (      
          <div>
            <Home/> 
          </div>
          );
      }
      
      
    }
    return (      
    	<div>
        <Loading/>      				
      </div>
      );
    }
  }


export default connect(mapStateToProps,mapDispatchToProps)(Connexion);



// WEBPACK FOOTER //
// ./src/components/Connexion.js